import {createApp} from 'vue';
import LoadingComponent from '../../components/loading.vue';

const MyLoading = {};
let container = null;
let instance = null;
let isShow = false;

MyLoading.install = (app) => {
  if (app._myLoadingInstalled) return;
  app._myLoadingInstalled = true;

  const createLoadingInstance = (tips = '') => {
    if (!container) {
      container = document.createElement('div');
      document.body.appendChild(container);
      const loadingApp = createApp(LoadingComponent, {content: tips});
      instance = loadingApp.mount(container);
    }
    instance.content = tips;
    instance.isShowLoading = true;
    isShow = true;
  };

  const hideLoading = () => {
    if (instance) {
      instance.isShowLoading = false;
      isShow = false;
    }
  };

  app.config.globalProperties.$myLoading = (tips) => {
    createLoadingInstance(tips);
  };
  app.config.globalProperties.$myLoading.show = (tips) => createLoadingInstance(
      tips);
  app.config.globalProperties.$myLoading.hide = hideLoading;
};

export default MyLoading;
